import { Dispatch } from "redux";

import { loadAndTrack } from "redux-request-loading";

import { Payload } from "@neworbit/redux-helpers";

import * as actions from "./actiontypes";
import * as models from "./model";
import { sraDepartmentApi } from "./sraDepartmentApi";

import { push } from "redux-little-router";

export type SraDepartmentAction =
      ({ type: typeof actions.LOAD_SRADEPARTMENTS_SUCCESS } & Payload<models.SraDepartmentListModel[]>)
    | ({ type: typeof actions.CREATE_SRADEPARTMENT_SUCCESS } & Payload<models.SraDepartmentDetailModel>)
    | ({ type: typeof actions.LOAD_SRADEPARTMENT_DETAIL_SUCCESS } & Payload<models.SraDepartmentDetailModel>)
    | ({ type: typeof actions.SAVE_SRADEPARTMENT_SUCCESS } & Payload<models.SraDepartmentDetailModel>)
    | ({ type: typeof actions.DELETE_SRADEPARTMENT_SUCCESS } & Payload<any>);

export const loadSraDepartmentsSuccess = (payload: models.SraDepartmentListModel[]): SraDepartmentAction => ({
    payload,
    type: actions.LOAD_SRADEPARTMENTS_SUCCESS
});

export const createSraDepartmentSuccess = (payload: models.SraDepartmentDetailModel): SraDepartmentAction => ({
    payload,
    type: actions.CREATE_SRADEPARTMENT_SUCCESS
});

export const saveSraDepartmentSuccess = (payload: models.SraDepartmentDetailModel): SraDepartmentAction => ({
    payload,
    type: actions.SAVE_SRADEPARTMENT_SUCCESS
});

export const deleteSraDepartmentSuccess = (id: any): SraDepartmentAction => ({
    payload: id,
    type: actions.DELETE_SRADEPARTMENT_SUCCESS
});

export function createSraDepartment(sraCustomerId: string, sraDepartment: models.SraDepartmentCreateModel, path: string) {
    return async (dispatch: Dispatch) => {
        const result = await loadAndTrack(dispatch, "createSraDepartment", sraDepartmentApi.create(sraCustomerId, sraDepartment));
        dispatch(createSraDepartmentSuccess(result));
        dispatch(push(`${path}/${result.id}`, {}));
    };
}

export function saveSraDepartment(sraCustomerId: string, sraDepartment: models.SraDepartmentEditModel, path?: string) {
    return async (dispatch: Dispatch) => {
        const result = await loadAndTrack(dispatch, "saveSraDepartment", sraDepartmentApi.save(sraCustomerId, sraDepartment));

        dispatch(saveSraDepartmentSuccess(result));
        if (path !== undefined) {
            dispatch(push(`${path}/${result.id}`, {}));
        }
    };
}

export function deleteSraDepartment(sraCustomerId: string, id: string, path: string) {
    return async (dispatch: Dispatch) => {
        await loadAndTrack(dispatch, "deleteSraDepartment", sraDepartmentApi.delete(sraCustomerId, id));
        dispatch(deleteSraDepartmentSuccess(id));
        dispatch(push(`${path}`, {}));
    };
}

export function loadSraDepartments({ sraCustomerId }: { sraCustomerId: string }) {
    return async (dispatch: Dispatch) => {
        const result = await loadAndTrack(dispatch, "loadSraDepartments", sraDepartmentApi.getAll(sraCustomerId));
        dispatch(loadSraDepartmentsSuccess(result));
    };
}

export const loadSraDepartmentDetailSuccess = (sraDepartment: models.SraDepartmentDetailModel) => ({
    payload: sraDepartment,
    type: actions.LOAD_SRADEPARTMENT_DETAIL_SUCCESS
});

export function loadSraDepartmentDetail({ sraCustomerId, sraDepartmentId }: { sraCustomerId: string; sraDepartmentId: string}) {
    return async  (dispatch: Dispatch, getState: () => models.AppState) => {
        const sraDepartment = getState().sraDepartments.filter(c => c.id === sraDepartmentId)[0];

        if (sraDepartment === undefined
            || sraDepartment.detailUpdated === undefined
            || sraDepartment.detailUpdated.isBefore(sraDepartment.listUpdated)) {

            const result = await loadAndTrack(dispatch, "loadSraDepartmentDetail", sraDepartmentApi.detail(sraCustomerId, sraDepartmentId));
            dispatch(loadSraDepartmentDetailSuccess(result));
        }
    };
}
